import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsCard,
  WorkProgress
}                         from '../../../components';
import { getMerchantType } from '../../../redux/actions/merchantActions';
import { getAllCategories } from '../../../redux/actions/categories';
import { getCititesForReport, getSalesPersonReport , getSalesPersonExportReport} from '../../../redux/actions/salesPersonActions';
import {renderAlert,clearAlert} from '../../../redux/actions/alertsActions';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Panel,
  PanelGroup
  
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import loader from '../../../style/loader/loader.scss';
import Dialog from 'react-bootstrap-dialog'
import ReactAutocomplete from 'react-autocomplete';
import { Link } from "react-router-dom";
import DatePicker from 'react-date-picker';
// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';
import isEmpty from 'lodash.isempty';

import  '../dashboard/dashboard.scss'
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';

const history = createBrowserHistory();

let isLoading='false', totalvouchertobesold=0;  let tableData = [], csv=[], reportData=[], exportReport=[], csvData=[] ;
class Dashboard extends Component {

  static propTypes = {
    isOpened: PropTypes.bool
  };

  static defaultProps = {
    isOpened: false
  };
  constructor(props){

    super(props);
    this.state={
      //path: ['Home', 'Sales person', 'Dashboard'], 
      show: false,
      alertMessage:'',
      date: new Date(),
      range: false,
      disabled: false,
      catID: '',
      merchantTypeID: '',
      sales: [],
      cities:[],
      expandedRows : [],
      active: true,
      reportData:[],
      filename:"dashboard-data",
      isOpened: this.props.isOpened,
      exportReport:[],
      trindex:0,
      csvData: ''
    }
    this.handleChange=this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate=this.validate.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
    this.export_table_to_csv=this.export_table_to_csv.bind(this);
    this.download_csv=this.download_csv.bind(this);
    this.exportCSV=this.exportCSV.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date })
  onChangeStartDateRange = date => this.setState({ startDateRange: date})
  changeDatePicker = status => {
    if(this.state.range == false){
      this.setState({range: true})
    }else{
      this.setState({range: false})
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e){
    
    if(`${e.target.name}Error` !== ''){
     
      this.setState({[`${e.target.name}Error`]:''})
    }
   
    this.setState({[e.target.name]:e.target.value}) 
    
  }

  handleClick(cindex){
    let opened=this.state.isOpened? false:true;
    this.setState({isOpened: !this.state.isOpened}) 
    this.setState({ collapse: this.state.collapse === cindex ? null : cindex });
  }

  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.props.getMerchantType();
    this.props.getAllCategories();
    this.props.getSalesPersonReport();
    this.props.getSalesPersonExportReport();
    isLoading="true";
  }

  componentWillReceiveProps(nextProps){    
    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        isLoading="false";
        this.setState({sales: ''})
      }
    } 

    if(this.props.merchantType !== nextProps.merchantType){
      if(nextProps.merchantType){
        this.setState({merchantType: nextProps.merchantType})
      }
    }

    if(this.props.catData !== nextProps.catData){
      if(nextProps.catData){
        this.setState({catData: nextProps.catData.data.data})
      }
    }

    if(this.props.reportData !== nextProps.reportData){
      if(nextProps.reportData){
        this.setState({reportData: nextProps.reportData.data})
        isLoading="false";
       
      }
    } 

    if(this.props.exportReport !== nextProps.exportReport){
      if(nextProps.exportReport){
        this.setState({exportReport: nextProps.exportReport.data})
        isLoading="false";
   
      }
    } 

    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
    }
   
}

validate = () => { 
  let isError = false;
  const errors = {};

  return isError;

}


handleSubmit(e){
  e.preventDefault();
  const err = this.validate();
  let formData;

  if(!err) {
    this.setState({sales: ''})
    isLoading = 'true';
    if(this.state.range == true){
      let dateRange = this.state.startDateRange;
      formData = {
        startDate: dateRange[0],
        endDate: dateRange[1],
        catID: this.state.catID,
        merchantTypeID: this.state.merchantTypeID,
      }
    }else{
      formData = {
        startDate: this.state.startDate,
        catID: this.state.catID,
        merchantTypeID: this.state.merchantTypeID,
      }
    }

    this.props.getSalesPersonReport(formData);
  }
}


download_csv(csv, filename) {
  var csvFile;
  var downloadLink;

  // CSV FILE
  csvFile = new Blob([csv], {type: "text/csv"});

  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);

  // Make sure that the link is not displayed
  downloadLink.style.display = "none";

  // Add the link to your DOM
  document.body.appendChild(downloadLink);

  // Lanzamos
  downloadLink.click();
}

export_table_to_csv(html, filename) {
  
  var csv = [];
  var rows = document.querySelectorAll("table.tableDataReport tr");
    
    for (var i = 0; i < rows.length; i++) {
    var row = [], cols = rows[i].querySelectorAll("td, th");
      
        for (var j = 0; j < cols.length; j++){
          
          if(cols[j].innerText.indexOf('Merchant NameOffer') < 0){
            row.push(cols[j].innerText);
           
          }
        }

      if(row.length < 20){
      csv.push(row.join(","));
      }  
      else{
        let rowLabel = row[0];
        if(rowLabel.charAt(0) =='#'){
          csv.push([rowLabel].join(","));
        }
      }  
  }
    this.download_csv(csv.join("\n"), filename);
}

exportCSV(){
  var html = document.querySelector(".tableDataReport").outerHTML;
  this.export_table_to_csv(html, "dashboard-data.csv");
}


  render() {
    if(this.props.error){
      isLoading="false";
    }
   
    let trtData='';
    const isOpened = this.state;
    let cheaders = [
      { label: 'First Name', key: 'details.firstName' },
      { label: 'Last Name', key: 'details.lastName' },
      { label: 'Job', key: 'job' },
    ];

    let cdata = [
      { details: { firstName: 'Ahmed', lastName: 'Tomi' }, job: 'manager'},
      { details: { firstName: 'John', lastName: 'Jones' }, job: 'developer'},
    ];  
    if (!isEmpty(this.state.reportData)){ 
      
      reportData = this.state.reportData[0];
      Object.keys(reportData).map((data, key) => {
             
              tableData[key] = {'country' : data};
              
              Object.keys(reportData[data]).map((cval,cindex)=> {
               
                  if(tableData[key].total){
                    tableData[key].total.push({'th': cval,'data': reportData[data][cval] });
                     
                  }
                  else
                  {
                       tableData[key].total = [{'th': cval,'data': reportData[data][cval] }];

                  }
                    if(cval=="countryvoucherstobesold" || cval=="countryvouchersavailable" || cval=="countryquantity" ||
                      cval=="countrygrossBilling" || cval=="countryrevenue"){
                      
                        
                      }else{
                        if(tableData[key].city){
                        tableData[key].city.push({'name' : cval, 'children' : reportData[data][cval] });
                        }else{
                            tableData[key].city = [{'name' : cval,'children' : reportData[data][cval]}];
                        }
                    
                    } 
                  
              })
      })
    
    
     
    }

  
    let countrytotal='';
    let voucherstobesold;
    let vouchersavailable;
    let quantity;
    let revenue;
    let grossBilling;
    let totalvoucherstobesold=0;
    let totalvouchersavailable;
    let totalquantity;
    let totalgrossBilling;
    let totalrevenue;
     
    return (
      <div className="col-lg-12 add-sub-admin">
      {(isLoading =='true') ? 
        <div className="loader">
          <p className="loading-message">
          <i>
              Loading...
          </i>
          </p>
          <div className="spinner">
              <div className="dot1"></div>
              <div className="dot2"></div>
          </div>
        </div> : ''
      }
     
      <form onSubmit={this.handleSubmit}>
      <div className="panel">
        <header className="panel-heading">Dashboard</header>
        <div className="panel-body">
          <Row>
           
            <Col md={4} xs={12}>
              <ControlLabel>Date</ControlLabel>
                <FormGroup controlId="formOfferTitle">
                  {(this.state.range == false) ?
                    <DatePicker
                      onChange={this.onChangeStartDate}
                      value={this.state.startDate}
                    />
                  : ''
                    // <DateRangePicker
                    //   onChange={this.onChangeStartDateRange}
                    //   value={this.state.startDateRange}
                    // />
                  }
                </FormGroup>
            </Col>
            <Col md={4} xs={12}>
              <FormGroup controlId="proposalType">
                <ControlLabel>Proposal Type</ControlLabel>
                <FormControl componentClass="select" style={{borderColor:this.state.merchantTypeIDError}} name="merchantTypeID" onChange={this.handleChange} value={this.state.merchantTypeID}>
                  <option value="">All</option>
                  {(!isEmpty(this.state.merchantType)) && 
                    this.state.merchantType.map((type, index) => 
                      <option key={type.merchantTypeID} value={type.merchantTypeID}>{type.merchantTypeName}</option>
                    )
                  }
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={4} xs={12}>
                <FormGroup controlId="catID">
                  <ControlLabel>Category</ControlLabel>
                  <FormControl componentClass="select" style={{borderColor:this.state.catIDError}} name="catID"  onChange={this.handleChange} value={this.state.catID}>
                    <option value="">All</option>
                    {(!isEmpty(this.state.catData)) && 
                      this.state.catData.map((type, index) => 
                        <option key={type.catID} value={type.catID}>{type.catName}</option>
                      )
                    }
                  </FormControl>
                
                </FormGroup>
              </Col>
          </Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Submit</Button>
              {(this.state.range == false) ?
                <a className="btn btn-success" type="submit" onClick={this.changeDatePicker} id="saveButton">Use Range</a>
              :
                <a className="btn btn-success" type="submit" onClick={this.changeDatePicker} id="saveButton">Use Date</a>
              }
             
              <Button bsStyle="info" type="submit" onClick={this.exportCSV}>Export</Button>
            </Col>
          </Row>
        </div>
      </div> 
      </form>
   

      <div className="panel">
      <header className="panel-heading">Today's Sales</header>
      
        <div className="panel-body table-responsive">

          <table className="table table-condensed tableDataReport" style={{borderCollapse:'collapse'}}>
          {tableData.map((data, index) =>
            <tbody>
                
                <tr>
                  <th></th>
                  <th>Vouchers To be Sold</th>
                  <th>Vouchers Available for Sale</th>
                  <th>Quantity</th>
                  <th>Revenue</th>
                  <th>Gross Billings</th>
                  
                </tr>
              
                <tr key={index}>
                  <td colSpan="6" > <b>Country:</b> {data.country}</td>
                  </tr>
            
                      {data.total.map((tt,cindex)=> {
                      
                      if(tt.th == 'countryvoucherstobesold') {
                     
                     
                           totalvoucherstobesold=tt.data;
                      
                     
                      }else if(tt.th == 'countryvouchersavailable'){
                        totalvouchersavailable=tt.data;
                      }else if(tt.th == 'countryquantity'){
                        totalquantity=tt.data;
                      }else if(tt.th == 'countryrevenue'){
                        totalrevenue=tt.data;
                      }else if(tt.th == 'countrygrossBilling'){
                        totalgrossBilling=tt.data;
                      }
                   
                    })}
                      
                  <tr>
                      <td><b>All Markets</b></td>
                      <td>{totalvoucherstobesold} </td>
                      <td>{totalvouchersavailable} </td>
                      <td> {totalquantity}</td>
                      <td>{localStorage.getItem('symbol')}{totalrevenue}</td>
                      <td>{localStorage.getItem('symbol')}{totalgrossBilling}</td>
                  </tr>
                  
              
              {data.city.map((cval,cindex)=> {
                  
                  return (
                  
                  <tr key={cindex}>
                    <td>   <Button id={cindex} bsSize="xsmall" bsStyle="success" onClick={this.handleClick.bind(this,cval.name)}> {'#'+cval.name} </Button>
                  
                        <div key={cindex} className={cval.name===this.state.collapse?'show':'hidden'}>
                       
                         
                          <div key={cindex}> 
                           <table>
                               <tr key={this.state.trindex}>
                                   <td>
                                   <table id="city-282">
                      <tbody><tr>
                      <th >Merchant Name</th>
                      <th>Offer ID</th>
                      <th>Offer Offer</th>
                      <th>Offer Price</th>
                      <th>Remittance</th>
                      <th>Pause?</th>
                      <th>Sales Rep</th>
                      <th>Date Contract Signed</th>
                      <th>Date Contract Expiration</th>
                      <th>Vouchers To be Sold</th>
                      <th>Vouchers Available for Sale</th>
                      <th>Quantity</th>
                      <th>Revenue</th>
                      <th>Gross Billings</th>
                      </tr>
                      {Object.keys(cval).map((child,chindex)=> {
                        if(child == 'children') {
                         return(
                         Object.keys(cval[child]).map((cd,cdindex)=> {
                          if(cval[child][cd].merchantName){
                            return (     
                              <tr key={cdindex}>
                              <td>
                              {cval[child][cd].merchantName}
                              </td>
                              <td>{cval[child][cd].dealID}</td>
                              <td>{cval[child][cd].dealText}</td>
                              <td>{cval[child][cd].offerPrice}</td>
                              <td> {cval[child][cd].remittance} </td>
                              <td>{(cval[child][cd].paused=="0")? "No": "Yes"}</td>
                              <td> {cval[child][cd].SalesPerson} </td>
                              <td> {moment(cval[child][cd].DateContractSigned).format("YYYY-MM-DD")} </td>
                              <td> {moment(cval[child][cd].DateContractEnd).format("YYYY-MM-DD")} </td>
                              <td className="center" > {cval[child][cd].VouchersToBeSold}</td>
                              <td className="center" > {cval[child][cd].VouchersAvailableForSale} </td>
                              <td className="center" > {cval[child][cd].quantity} </td>
                              <td className="center" > {cval[child][cd].revenue} </td>
                              <td className="center" > {cval[child][cd].grossBilling} </td>
                              </tr>
                            );
                          }
                         })
                         );
                        }
                      })}
                      
                      </tbody></table>
                                   </td>
                               </tr>
                               </table>
                               </div>
                         
                          </div> 
                      </td>

                      {Object.keys(cval).map((child,chindex)=> {
                        if(child == 'children') {
                       
                        voucherstobesold=cval[child].voucherstobesold;
                        vouchersavailable=cval[child].vouchersavailable;
                        quantity=cval[child].quantity;
                        revenue=cval[child].revenue;
                        grossBilling=cval[child].grossBilling;
                       
                      }})}
                      <td>{voucherstobesold}</td>
                      <td>{vouchersavailable}</td>
                      <td>{quantity}</td>
                      <td>{localStorage.getItem('symbol')}{revenue}</td>
                      <td>{localStorage.getItem('symbol')}{grossBilling}</td>
                  </tr>
                  
                  );
                  })}
                 
               
              </tbody>
          )}
            </table>
        </div>
      </div>
     
    </div>
    
    );
  }
}

const mapStateToProps = state => ({
  
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  merchantType:  state.merchantReducer.merchantType,
  catData: state.categoryReducer.catData,
  reportData: state.salesPersonReducer.reportData,
  citiesReportData: state.salesPersonReducer.citiesReportData,
  exportReport:state.salesPersonReducer.exportReport,
  error: state.salesPersonReducer.error
})

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps,{renderAlert,clearAlert,getMerchantType, getSalesPersonExportReport,getAllCategories,getCititesForReport, getSalesPersonReport })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/salesPerson/dashboard/Dashboard.js